import { FEATURE_FLAGS } from '../../../featureFlags';
import EmpresasList from './EmpresasList.vue';
import EmpresaDetails from './EmpresaDetails.vue';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.EMPRESAS,
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: 'empresas',
    name: 'empresas_list',
    component: EmpresasList,
    meta: commonMeta,
  },
  {
    path: 'empresas/:empresaId(\\d+)',
    name: 'empresa_details',
    component: EmpresaDetails,
    meta: commonMeta,
    props: route => ({ empresaId: route.params.empresaId }),
  },
];

export default routes;
